import React, { Component } from 'react';
import { Card, Form, Table } from 'antd';
import util from '@util/index';
import { connect } from 'react-redux';
import { getWorkOrgList } from '@store/modules/work_org_list';
import { BackBtn } from '@comm/BackBtn';
import { queryBonusDetailInfo } from '@api/hr/bonus';

class Manage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dataSource: [],
    };
  }

  componentDidMount() {
    this.props.dispatch(getWorkOrgList());
    this.getBonusDetailInfo();
  }

  getBonusDetailInfo = () => {
    queryBonusDetailInfo({ uuid: this.props.params.uuid }).then(res => {
      if (res.statusCode === 200) {
        const { workOrg } = this.props;
        const dataSource = [res.data];
        workOrg.map(item => {
          if (item.uuid === res.data.workorgname) {
            dataSource[0].workorgname = item.name;
          }
          return item;
        });
        this.setState({
          dataSource: [res.data],
        });
      }
    });
  };

  columns = () => {
    return [
      {
        title: '公司',
        dataIndex: 'compname',
        width: 50,
      },
      {
        title: '部门',
        dataIndex: 'workorgname',
        width: 50,
      },
      {
        title: '年份',
        dataIndex: 'year',
        width: 50,
      },
      {
        title: '姓名',
        dataIndex: 'person',
        width: 50,
      },

      {
        title: '应发项目',
        children: [
          {
            title: '基本工资',
            dataIndex: 'base',
            width: 50,
            render: text => <span>{util.numberFormat(text, 2, '.', ',')}</span>,
          },
          {
            title: '绩效工资',
            dataIndex: 'performance',
            width: 50,
            render: text => <span>{util.numberFormat(text, 2, '.', ',')}</span>,
          },
        ],
      },
      {
        title: '税前年终奖',
        dataIndex: 'pretax',
        width: 50,
        render: text => <span>{util.numberFormat(text, 2, '.', ',')}</span>,
      },
      {
        title: '个税',
        dataIndex: 'personalTax',
        width: 50,
        render: text => <span>{util.numberFormat(text, 2, '.', ',')}</span>,
      },
      {
        title: '实发年终奖',
        dataIndex: 'netPay',
        width: 50,
        render: text => <span>{util.numberFormat(text, 2, '.', ',')}</span>,
      },
    ];
  };

  render() {
    const { dataSource } = this.state;

    return (
      <div>
        <div style={{ marginBottom: '16px' }}>
          <BackBtn />
        </div>
        <Card>
          <Table
            size="small"
            bordered
            columns={this.columns()}
            dataSource={dataSource}
            pagination={false}
            rowKey="uuid"
            onChange={this.handleTableChange}
            scroll={{ x: 1630 }}
          />
        </Card>
      </div>
    );
  }
}

export default connect(state => ({
  workOrg: state.work_org_list,
}))(Form.create({ wrappedComponentRef: true })(Manage));



// WEBPACK FOOTER //
// ./src/components/home/wage/PageDetailBonus.js